const analyticsService = {
    Page: {
        pagename: "", //Pagename
        brand_name: "", // Brand of Site/Product name
        member_id: "",
        cid: "",
        customer_id: "",
        tc: "",
        channel: "",
        device_type: "", // Mobile/Desktop
        site_country: "", // Country of Site
        site_language: "" // Language of Site
    },
    getDigitalData() {
        return this.Page;
    },
    setDigitalData(dAnalyticsData) {
        this.Page = dAnalyticsData;
        window.digitalData = dAnalyticsData;
    },
    setTrack(trackName, options) {
        if (window._satellite === undefined) {
            // console.log('Not Loaded');
            return;
        }
        switch (trackName) {
            case 'AddtoWalletClick':
                window._satellite.track(trackName, {
                    walletName: options ? options.walletName : "",
                    memberID: options ? options.memberID : "",
                    cid: options ? options.cid : "",
                    customerID: options ? options.customerID : "",
                    tc: options ? options.tc : "",
                    channel: options ? options.channel : ""
                });
                break;
            default: break;
        }
    }
};

export default analyticsService;